import _typeof from "@babel/runtime/helpers/typeof";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as Common from './Common.styles';

var ListSection = function ListSection(_ref) {
  var title = _ref.title,
      content = _ref.content,
      unit = _ref.unit,
      type = _ref.type,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("section", {
    className: className
  }, /*#__PURE__*/React.createElement(Common.Heading, null, title), content.map(function (_ref2, listIndex) {
    var description = _ref2.description,
        list = _ref2.list;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: listIndex
    }, description && /*#__PURE__*/React.createElement(Common.Description, null, description), list && /*#__PURE__*/React.createElement(React.Fragment, null, type === 'ol' ? /*#__PURE__*/React.createElement(Common.OrderedList, null, list.map(function (item, itemIndex) {
      return /*#__PURE__*/React.createElement("li", {
        key: itemIndex
      }, _typeof(item) === 'object' ? item[unit] : item);
    })) : /*#__PURE__*/React.createElement(Common.UnorderedList, null, list.map(function (item, itemIndex) {
      return /*#__PURE__*/React.createElement("li", {
        key: itemIndex
      }, _typeof(item) === 'object' ? item[unit] : item);
    }))));
  }));
};

ListSection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
      inch: PropTypes.string,
      cm: PropTypes.string
    }), PropTypes.string]))
  })).isRequired,
  unit: PropTypes.oneOf(['cm', 'inch']),
  type: PropTypes.oneOf(['ul', 'ol']),
  className: PropTypes.string
};
ListSection.defaultProps = {
  unit: 'cm',
  type: 'ul',
  className: null
};
export default ListSection;